import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { cssText } from './theme/tokens';

// Inject the single-source color tokens as :root CSS variables (before first paint).
const tokenStyle = document.createElement('style');
tokenStyle.id = 'app-color-tokens';
tokenStyle.textContent = cssText;
document.head.prepend(tokenStyle);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
